import { create } from "zustand";
import { persist } from "zustand/middleware";

/**
 * Minimal global UI state (frontend.md: "keep Zustand minimal"). Server state
 * lives in TanStack Query; this holds only the active channel and transient
 * overlay flags.
 */
interface AppState {
  /** The channel all read surfaces are scoped to. Persisted across opens. */
  activeChannelId: string | null;
  setActiveChannel: (id: string) => void;

  channelSwitcherOpen: boolean;
  adminHubOpen: boolean;
  setChannelSwitcherOpen: (open: boolean) => void;
  setAdminHubOpen: (open: boolean) => void;
}

export const useAppStore = create<AppState>()(
  persist(
    (set) => ({
      activeChannelId: null,
      setActiveChannel: (id) => set({ activeChannelId: id }),
      channelSwitcherOpen: false,
      adminHubOpen: false,
      setChannelSwitcherOpen: (open) => set({ channelSwitcherOpen: open }),
      setAdminHubOpen: (open) => set({ adminHubOpen: open }),
    }),
    {
      name: "cml-app",
      // Only the channel selection is worth persisting; overlay flags reset.
      partialize: (s) => ({ activeChannelId: s.activeChannelId }),
    },
  ),
);
